import type * as core from '../../../../../../../core'

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'High-Risk Change Impacts',
      type: 'table',
      content: {
        '{}': {
          query: {
            '`': {
              filter: {
                and: [
                  {
                    '!=': [
                      {
                        '@.': '!status',
                      },
                      'Complete',
                    ],
                  },
                  {
                    or: [
                      {
                        '=': [
                          {
                            '@.': '!priority',
                          },
                          'High',
                        ],
                      },
                      {
                        '=': [
                          {
                            '@.': '!degree_of_change',
                          },
                          'High',
                        ],
                      },
                      {
                        '=': [
                          {
                            '@.': '!value_of_change',
                          },
                          'High',
                        ],
                      },
                      {
                        '=': [
                          {
                            '@.': '!area_of_concern',
                          },
                          true,
                        ],
                      },
                    ],
                  },
                ],
              },
              target: 'ent:!change_impacts:!change_impact',
              selection: {
                '{}': {
                  fields: {
                    '{}': {
                      code: {
                        '{}': {
                          value: {
                            '@.': '!code',
                          },
                        },
                      },
                      name: {
                        '{}': {
                          value: {
                            '@.': '!name',
                          },
                        },
                      },
                      priority: {
                        '{}': {
                          value: {
                            '@.': '!priority',
                          },
                        },
                      },
                      areaOfConcern: {
                        '{}': {
                          value: {
                            '@.': '!area_of_concern',
                          },
                        },
                      },
                      valueOfChange: {
                        '{}': {
                          value: {
                            '@.': '!value_of_change',
                          },
                        },
                      },
                      degreeOfChange: {
                        '{}': {
                          value: {
                            '@.': '!degree_of_change',
                          },
                        },
                      },
                      workstream: {
                        '{}': {
                          value: {
                            '@.': '!workstream',
                          },
                        },
                      },
                      validationStatus: {
                        '{}': {
                          value: {
                            '@.': '!validation_status',
                          },
                        },
                      },
                    },
                  },
                },
              },
            },
          },
          columns: {
            '[]': [
              {
                '{}': {
                  id: 'code',
                  direct: {
                    '{}': {
                      name: 'Impact ID',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'name',
                  direct: {
                    '{}': {
                      name: 'Change Impact Title',
                      type: 'TEXT',
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'workstream',
                  direct: {
                    '{}': {
                      name: 'Workstream',
                      type: {
                        '{}': {
                          enumId: 'enum::!change_impact_workstream',
                          isMultiselect: true,
                        },
                      },
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'validationStatus',
                  direct: {
                    '{}': {
                      name: 'Validation Status',
                      type: {
                        '{}': {
                          enumId: 'enum::!change_impact_validation_status',
                          isMultiselect: false,
                        },
                      },
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'priority',
                  direct: {
                    '{}': {
                      name: 'Priority',
                      type: {
                        '{}': {
                          enumId: 'enum::!change_impact_rank',
                          isMultiselect: false,
                        },
                      },
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'degreeOfChange',
                  direct: {
                    '{}': {
                      name: 'Degree of Change',
                      type: {
                        '{}': {
                          enumId: 'enum::!change_impact_rank',
                          isMultiselect: false,
                        },
                      },
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'valueOfChange',
                  direct: {
                    '{}': {
                      name: 'Value of Change',
                      type: {
                        '{}': {
                          enumId: 'enum::!change_impact_rank',
                          isMultiselect: false,
                        },
                      },
                    },
                  },
                  isSortable: true,
                },
              },
              {
                '{}': {
                  id: 'areaOfConcern',
                  direct: {
                    '{}': {
                      name: 'Area of Concern',
                      type: 'BOOL',
                    },
                  },
                  isSortable: true,
                },
              },
            ],
          },
        },
      },
    },
  },
}
